import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';
import PrintIcon from '@mui/icons-material/Print';
import QRCode from 'qrcode';

export default function QRCodeDisplay({ url, title, onPrint }) {
  const [dataUrl, setDataUrl] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let isMounted = true;
    async function gen() {
      if (!url) return;
      try {
        const d = await QRCode.toDataURL(url, { width: 300, margin: 2 });
        if (isMounted) setDataUrl(d);
      } catch (e) {
        console.error('QR error', e);
      }
    }
    gen();
    return () => { isMounted = false; };
  }, [url]);

  const handlePrint = () => {
    if (onPrint) return onPrint(dataUrl);
    const w = window.open('', '_blank');
    w.document.write(`<!doctype html><html><head><title>${title || 'QR Code'}</title></head><body style="margin:0;padding:24px;font-family:Arial;text-align:center">
      <h2 style="margin:0 0 16px">${title || ''}</h2>
      <img src="${dataUrl}" alt="QR" style="border:2px solid #000;padding:8px"/>
      <p style="color:#666">Scan to view details</p>
    </body></html>`);
    w.document.close();
    w.print();
  };

  if (!url) return null;

  return (
    <Box sx={{ textAlign: 'center' }}>
      {dataUrl && (
        <img src={dataUrl} alt="QR" style={{ width: 120, height: 120, border: '1px solid #ddd', borderRadius: 4 }} />
      )}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 1 }}>
        <Tooltip title="View QR">
          <IconButton size="small" onClick={() => setOpen(true)} color="primary">
            <QrCodeIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Print QR">
          <IconButton size="small" onClick={handlePrint} color="primary">
            <PrintIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{title || 'QR Code'}</DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
          {dataUrl && <img src={dataUrl} alt="QR" style={{ width: '100%', maxWidth: 300 }} />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePrint} startIcon={<PrintIcon />}>Print</Button>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
} 